module.exports = {"420984001":"仙女山街道","420984002":"汈东街道","420984100":"马口镇","420984101":"脉旺镇","420984102":"城隍镇","420984103":"分水镇","420984104":"沉湖镇","420984105":"田二河镇","420984106":"回龙镇","420984107":"新堰镇","420984108":"垌塚镇","420984109":"麻河镇","420984110":"刘家隔镇","420984111":"新河镇","420984112":"庙头镇","420984113":"杨林沟镇","420984200":"西江乡","420984201":"湾潭乡","420984202":"南河乡","420984203":"马鞍乡","420984204":"里潭乡","420984205":"韩集乡","420984450":"国营中洲农场","420984500":"华严农场","420984502":"三星垸原种场","420984503":"汈汊湖养殖场","420984504":"汉川市经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420984.json
// module id = 1612
// module chunks = 0